<template>
  <v-row align="start" justify="center">
    <v-col cols="12">
      <tif-terminal-editor />
      <tif-command-table />
    </v-col>
  </v-row>
</template>

<script>
import Table from "@/components/commands/Table.vue";
import EditorBar from "@/components/terminals/EditorBar.vue";
export default {
  name: "Commands",
  components: {
    "tif-command-table": Table,
    "tif-terminal-editor": EditorBar
  }
};
</script>

<style>
</style>